require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-general-comment-on-child-rights-and-the-environment.json") })
        }
      }, "path---en-us-update-general-comment-on-child-rights-and-the-environment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-general-comment-on-child-rights-and-the-environment!./.cache/json/en-us-update-general-comment-on-child-rights-and-the-environment.json
// module id = 670
// module chunks = 231608221292675